import api from '../services/api';
import Swal from 'sweetalert2';

export default function Empresas() {
  const container = document.createElement('div');
  container.className = 'content';

  // Card de título
  const header = document.createElement('div');
  header.className = 'card';
  header.innerHTML = `<h2>Empresas</h2>`;
  container.appendChild(header);

  // Card de ações
  const actions = document.createElement('div');
  actions.className = 'card inline';
  actions.innerHTML = `
    <input id="filtroEmp" class="form-input" placeholder="Filtrar por nome..." />
    <button id="btnCarregarEmp" class="btn btn-sm">Carregar</button>
    <button id="btnNovaEmp" class="btn primary btn-sm">Nova</button>
  `;
  container.appendChild(actions);

  // Card da tabela
  const grid = document.createElement('div');
  grid.className = 'card';
  grid.innerHTML = `
    <table class="table">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Endereço</th>
          <th>UF</th>
          <th>País</th>
          <th>Responsável</th>
          <th>Fone</th>
          <th>Email</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody id="tbEmpresas"></tbody>
    </table>
  `;
  container.appendChild(grid);

  // Função de carregar lista
  async function carregar() {
    const filtroInput = container.querySelector('#filtroEmp');
    const filtro = filtroInput ? filtroInput.value : '';
    try {
      const res = await api.get('/empresas', { params: { filtro } });
      const tbody = grid.querySelector('#tbEmpresas');
      tbody.innerHTML = res.data.map(e => `
        <tr>
          <td>${e.descricao}</td>
          <td>${e.endereco || ''}</td>
          <td>${e.uf || ''}</td>
          <td>${e.pais || ''}</td>
          <td>${e.responsavel || ''}</td>
          <td>${e.fone || ''}</td>
          <td>${e.email || ''}</td>
          <td>
            <button class="btn btn-sm edit" data-id="${e.cod_empresa}">
              <i class="fa-solid fa-pen"></i> Editar
            </button>
            <button class="btn btn-sm danger del" data-id="${e.cod_empresa}">
              <i class="fa-solid fa-trash"></i> Excluir
            </button>
          </td>
        </tr>
      `).join('');
      bind();
    } catch (err) {
      console.error('Erro ao carregar empresas:', err);
    }
  }

  // Bind dos botões da tabela
function bind() {
  grid.querySelectorAll('.edit').forEach(b =>
    b.onclick = () => editar(b.getAttribute('data-id')) // sem o "+"
  );
  grid.querySelectorAll('.del').forEach(b =>
    b.onclick = () => excluir(b.getAttribute('data-id')) // sem o "+"
  );
}

  // Excluir empresa
  async function excluir(id) {
    const result = await Swal.fire({
      title: 'Excluir empresa?',
      text: 'Essa ação não poderá ser desfeita!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar'
    });
    if (!result.isConfirmed) return;
    await api.delete(`/empresas/${id}`);
    Swal.fire({ title: 'Excluída!', icon: 'success', showConfirmButton: false, timerProgressBar: false, });
    carregar();
  }

  // Formulário de edição/criação
  async function editar(id) {
    const emp = id ? (await api.get('/empresas')).data.find(x => x.cod_empresa === id) : null;

  Swal.fire({
        timerProgressBar: false,
        title: id ? 'Editar Empresa' : 'Nova Empresa',
        html: `
            <form id="fEmp" style="display:flex;flex-direction:column;gap:6px;text-align:left;">
            <label style="display:flex;flex-direction:column;gap:5px;">
                Nome
                <input name="descricao" value="${emp?.descricao || ''}" required class="swal2-input" style="margin:0;" />
            </label>

            <label style="display:flex;flex-direction:column;gap:5px;">
                Endereço
                <input name="endereco" value="${emp?.endereco || ''}" class="swal2-input" style="margin:0;" />
            </label>

            <div style="display:flex;gap:8px;">
                <label style="flex:1;display:flex;flex-direction:column;gap:5px;">
                UF
                <input name="uf" value="${emp?.uf || ''}" class="swal2-input" style="margin:0;" />
                </label>
                <label style="flex:2;display:flex;flex-direction:column;gap:5px;">
                País
                <input name="pais" value="${emp?.pais || ''}" class="swal2-input" style="margin:0;" />
                </label>
            </div>

            <label style="display:flex;flex-direction:column;gap:5px;">
                Responsável
                <input name="responsavel" value="${emp?.responsavel || ''}" class="swal2-input" style="margin:0;" />
            </label>

            <label style="display:flex;flex-direction:column;gap:5px;">
                Fone
                <input name="fone" value="${emp?.fone || ''}" class="swal2-input" style="margin:0;" />
            </label>

            <label style="display:flex;flex-direction:column;gap:5px;">
                Email
                <input name="email" value="${emp?.email || ''}" class="swal2-input" style="margin:0;" />
            </label>
            </form>
        `,
        focusConfirm: false,
        showCancelButton: true,          // habilita o botão Cancelar
        confirmButtonText: 'Salvar',
        cancelButtonText: 'Cancelar',
        customClass: {
            title: 'swal2-title-left',
            actions: 'swal2-actions-custom'
        },
        preConfirm: async () => {
            const fd = new FormData(document.getElementById('fEmp'));
            const payload = Object.fromEntries(fd.entries());
            if (id) await api.put(`/empresas/${id}`, payload);
            else await api.post('/empresas', payload);
            carregar();
        }
        });



  }

  // Botões principais
  actions.querySelector('#btnCarregarEmp').onclick = carregar;
  actions.querySelector('#btnNovaEmp').onclick = () => editar();

  carregar();
  return container;
}
